<script>
import Notification from '../reUse/Notification.vue';
import DropDown from '../reUse/DropDown.vue';
import PorociloSkupno from './PorociloSkupno.vue';
import PorociloPiloti from './PorocilaPiloti.vue';
import PorociloLetala from './PorociloLetala.vue';
import PorociloVleke from './PorociloVleke.vue';
import Multiselect from 'vue-multiselect'
import {config} from "@/config";


export default {
  components: {
    Notification,
    DropDown,
    PorociloSkupno,
    PorociloPiloti,
    PorociloLetala,
    PorociloVleke,
    Multiselect
  },
  emits: ['odjava'],
  data() {
    const danes = new Date();
    const datumDo = `${danes.getFullYear()}-${String(danes.getMonth() + 1).padStart(2, '0')}-${String(danes.getDate()).padStart(2, '0')}`;
    const datumOd = `${danes.getFullYear()}-${String(danes.getMonth() + 1).padStart(2, '0')}-01`;

    return {
      prikaz: (config.FullUser.lvl < 2) ? 'vse' : 'piloti', // vse, piloti, letala, vleke
      vrstaLetala: 'motorno', // motorno, jadralno (for letala view)
      dPrikaz: false,
      datumOd,
      datumDo,
      izbranPilot: '',
      izbranPilotNaziv: '',
      izbranoLetalo: '',
      izbranoLetaloNaziv: '',
      pilot: [],
      primerjavaLeta: new Date().getFullYear() - 1,
      primerjavaVklopljena: true,
      user: config.FullUser,

// Dropdown states
      dPilot: false,
      dLetalo: false,

// Data
      piloti: [],
      letala: [],
      leta: [],

// Notifications
      text: '',
      types: '',
      ShowNoti: false,
    };
  },
  computed: {
    aktivniPrikazNaziv() {
      const map = {
        vse: 'Vse',
        piloti: 'Piloti',
        letala: 'Letala',
        vleke: 'Vleke'
      };
      return map[this.prikaz] || 'Pogled';
    },
    jeNeveljavenDatumRange() {
      if (!this.datumOd || !this.datumDo) {
        return true;
      }
      return this.datumOd > this.datumDo;
    },
    jeFilterVeljavno() {
      if (this.jeNeveljavenDatumRange) {
        return false;
      }
      if (this.prikaz === 'vse') {
        return true;
      }
      if (this.prikaz === 'piloti') {
        return !!this.izbranPilot;
      }
      if (this.prikaz === 'letala' || this.prikaz === 'vleke') {
        return !!this.izbranoLetalo;
      }
      return false;
    },
    letalaZaIzbiro() {
      if (this.prikaz === 'letala') {
        return this.letala.filter((l) => this.normalizirajVrstoLetala(l.vrsta_letala) === this.vrstaLetala);
      }
      return this.letala;
    }
  },
  watch: {
    prikaz() {
      this.dPrikaz = false;
      this.dLetalo = false;
      if (this.prikaz === 'piloti') {
        this.izbranoLetalo = '';
        this.izbranoLetaloNaziv = '';
      }
      this.uskladiIzbranoLetalo();
    },
    vrstaLetala() {
      this.uskladiIzbranoLetalo();
    },
    letala() {
      this.uskladiIzbranoLetalo();
    }
  },
  methods: {
    nastaviPrikaz(prikaz) {
      this.prikaz = prikaz;
      this.dPrikaz = false;
    },
    GenerateYears() {
      axios.get('./api/porocila/razpolozljiva-leta/', {withCredentials: true})
          .then((response) => {
            if (response.data.leta && response.data.leta.length > 0) {
              this.leta = response.data.leta.map(l => ({id: l, naziv: l.toString()}));
            } else {
              const currentYear = new Date().getFullYear();
              this.leta = [{id: currentYear, naziv: currentYear.toString()}];
            }
          })
          .catch(() => {
            const currentYear = new Date().getFullYear();
            for (let year = currentYear - 4; year <= currentYear; year++) {
              this.leta.push({id: year, naziv: year.toString()});
            }
          });
    },
    GetPiloti() {
      let url = './api/porocila/piloti/izpis/?osebni=1';
      if (this.user.lvl < 2) {
        url = './api/porocila/piloti/izpis/'
      }
      axios.get(url).then((response) => {
        this.piloti = response.data.piloti.map(p => ({
          id_pilota: p.id,
          email: p.email,
          id: p.sifra,
          naziv: `${p.ime} ${p.priimek}`
        }));
        if (this.user.lvl < 2) {
          this.piloti.unshift({
            id_pilota: 'vsi',
            email: 'vsi@wingsi.app',
            id: 'vsi',
            naziv: 'vsi piloti'
          });
        }
        if (this.piloti.length > 0) {
          this.izbranPilot = this.piloti.filter(pilot => pilot.email === this.user.email)[0].id;
          this.izbranPilotNaziv = this.piloti.filter(pilot => pilot.email === this.user.email)[0].naziv;
        }
      }).catch((napaka) => {
        if (napaka.response?.status === 401) {
          this.$router.push('/Logout');
        }
        this.text = 'Napaka pri pridobivanju pilotov: ' + (napaka.response?.data?.napaka || napaka.message);
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    GetLetala() {
      axios.get('./api/porocila/letala/izpis/').then((response) => {
        this.letala = response.data.letala.map(l => ({
          id: l.registracija,
          naziv: `${l.registracija} (${l.tip})`,
          vrsta_letala: l.vrsta_letala
        }));
        if (this.user.lvl < 2) { //za upravitelja in admine dodamo možnost pregleda vseh letal
          this.letala.unshift({
                "id": "vsi",
                "naziv": "Vsa letala",
                "vrsta_letala": "motorno"
              },
              {
                "id": "vsi",
                "naziv": "Vsa letala",
                "vrsta_letala": "jadralno",
              });
        }
        this.uskladiIzbranoLetalo();
      }).catch((napaka) => {
        if (napaka.response?.status === 401) {
          this.$router.push('/Logout');
        }
        this.text = 'Napaka pri pridobivanju letal: ' + (napaka.response?.data?.napaka || napaka.message);
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    selectPilot(id) {
      this.izbranPilot = id;
      const pilotObj = this.piloti.find(p => p.id === id);
      if (pilotObj) {
        this.izbranPilotNaziv = pilotObj.naziv;
      }
      this.dPilot = false;
    },
    selectLetalo(id) {
      this.izbranoLetalo = id;
      const letaloObj = this.letala.find(l => l.id === id);
      if (letaloObj) {
        this.izbranoLetaloNaziv = letaloObj.naziv;
      }
      this.dLetalo = false;
    },
    normalizirajVrstoLetala(vrsta) {
      return String(vrsta || '').trim().toLowerCase();
    },
    uskladiIzbranoLetalo() {
      if (!this.izbranoLetalo) return;
      const obstajaVFiltru = this.letalaZaIzbiro.some((l) => l.id === this.izbranoLetalo);
      if (!obstajaVFiltru) {
        this.izbranoLetalo = '';
        this.izbranoLetaloNaziv = '';
      }
    },
    PocistiFiltre() {
      const danes = new Date();
      this.datumOd = `${danes.getFullYear()}-${String(danes.getMonth() + 1).padStart(2, '0')}-01`;
      this.datumDo = `${danes.getFullYear()}-${String(danes.getMonth() + 1).padStart(2, '0')}-${String(danes.getDate()).padStart(2, '0')}`;
      // if (this.piloti.length > 0) {
      //   this.izbranPilot = this.piloti[0].id;
      //   this.izbranPilotNaziv = this.piloti[0].naziv;
      // } else {
      //   this.izbranPilot = '';
      //   this.izbranPilotNaziv = '';
      // }
      this.izbranoLetalo = '';
      this.izbranoLetaloNaziv = '';
    },
    izpisUporabnika({naziv, email}) {
      return `${naziv} [${email}]`;
    },
    nastaviPilota() {
      this.izbranPilot = this.pilot.id;
    },
  },
  mounted() {
    this.GenerateYears();
    this.GetPiloti();
    this.GetLetala();
  }
}
</script>
<template>
  <div class="pregled-povrsin-container">
    <div class="modern-header" style="position: relative; z-index: 1200; overflow: visible;">
      <div class="header-content" style="display: flex; flex-direction: column; align-items: stretch; gap: 0.75rem;">
        <div class="header-section header-center" style="justify-content: center; min-width: 0;">
          <h1 class="page-title" style="margin: 0; white-space: nowrap;">Poročila - {{ aktivniPrikazNaziv }}</h1>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; align-items: center; gap: 0.75rem;">
          <div class="header-section header-left" style="justify-content: flex-start; min-width: 0;">
            <button class="back-btn" @click.prevent="$router.push('/')">
              <i class="fas fa-arrow-left"></i>
              <span>Nazaj</span>
            </button>
          </div>

          <div class="header-section header-right" style="justify-content: flex-end; min-width: 0;">
            <div class="dropdown" style="position: relative; z-index: 1210;">
              <button class="back-btn" @click.prevent="dPrikaz = !dPrikaz"
                      style="min-width: 150px; justify-content: center;">
                <i class="fas fa-bars"></i>
                <span>Meni</span>
              </button>
              <transition name="fade">
                <div v-if="dPrikaz" class="list-group"
                     style="position: absolute; right: 0; top: calc(100% + 0.5rem); min-width: 200px; z-index: 1300; box-shadow: 0 8px 24px rgba(0,0,0,0.35);">
                  <button v-if="user.lvl < 2" type="button" class="list-group-item list-group-item-action"
                          :disabled="user.lvl >=2" :class="{'active': prikaz === 'vse'}" @click="nastaviPrikaz('vse')">
                    <i class="fas fa-chart-bar me-2"></i>Vse
                  </button>
                  <button type="button" class="list-group-item list-group-item-action"
                          :class="{'active': prikaz === 'piloti'}" @click="nastaviPrikaz('piloti')">
                    <i class="fas fa-user-clock me-2"></i>Piloti
                  </button>
                  <button v-if="user.lvl < 2" type="button" class="list-group-item list-group-item-action"
                          :disabled="user.lvl >=2" :class="{'active': prikaz === 'letala'}"
                          @click="nastaviPrikaz('letala')">
                    <i class="fas fa-plane me-2"></i>Letala
                  </button>
                  <button v-if="user.lvl < 2" type="button" class="list-group-item list-group-item-action"
                          :disabled="user.lvl >=2" :class="{'active': prikaz === 'vleke'}"
                          @click="nastaviPrikaz('vleke')">
                    <i class="fas fa-link me-2"></i>Vleke
                  </button>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container p-4">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="text" :type="types" @closeNotification="ShowNoti = false"/>
    </Transition>

    <div class="card mb-4 bg-cards text-white">
      <div class="card-header">
        <h5 class="card-title mb-0">Filtri</h5>
      </div>
      <div class="card-body">
        <div class="row g-3" style="margin-top: 0.5rem;">
          <div class="col-md-3">
            <label class="form-label">Datum od</label>
            <input class="input border-0 rounded-4 p-2 fs-5 w-100" type="date" v-model="datumOd"/>
          </div>

          <div class="col-md-3">
            <label class="form-label">Datum do</label>
            <input class="input border-0 rounded-4 p-2 fs-5 w-100" type="date" v-model="datumDo"/>
          </div>

          <div class="col-12" v-if="jeNeveljavenDatumRange">
            <div class="alert alert-warning mb-0">
              <i class="fas fa-exclamation-triangle"></i> Datum od mora biti manjsi ali enak datumu do.
            </div>
          </div>

          <div class="col-md-6" v-if="prikaz === 'piloti'">
            <label class="form-label">Pilot</label>
            <!--SAMOSTOJNI -->
            <div class="dropdown" v-if="user.lvl >=2">
              <button class="input border-0 rounded-4 p-2 fs-5 w-100" type="button" disabled style="text-align: left;">
                {{ izbranPilotNaziv || 'Izberi pilota' }}
                <small class="text-light ms-2">(samo tvoji leti)</small>
              </button>
            </div>
            <!-- MULTI -->
            <div class="dropdown" v-else>
              <multiselect v-model="pilot"
                           :options="piloti"
                           :custom-label="izpisUporabnika"
                           track-by="id"
                           @select="nastaviPilota()"
                           placeholder="Izberi / najdi uporabnika"
              >
                <template #noResult>
                  Uporabnik ne obstaja
                </template>

              </multiselect>
              <!--              <button class="input border-0 rounded-4 p-2 fs-5 w-100" type="button" disabled style="text-align: left;">-->
              <!--                {{ izbranPilotNaziv || 'Izberi pilota' }}-->
              <!--                <small class="text-light ms-2">(samo tvoji leti)</small>-->
              <!--              </button>-->
            </div>
          </div>

          <div class="col-12" v-if="prikaz === 'letala'">
            <label class="form-label d-block mb-2">Tip Letala</label>
            <div class="aircraft-type-slider">
              <label class="slider-toggle">
                <input type="checkbox" v-model="vrstaLetala" true-value="jadralno" false-value="motorno"
                       class="slider-input">
                <div class="slider-track">
                  <span class="slider-label slider-left">
                    <i class="fas fa-plane"></i> Motorno
                  </span>
                  <div class="slider-thumb"></div>
                  <span class="slider-label slider-right">
                    <i class="fas fa-paper-plane"></i> Jadralno
                  </span>
                </div>
              </label>
            </div>
          </div>

          <div class="col-md-6" v-if="prikaz === 'piloti' || prikaz === 'letala' || prikaz === 'vleke'">
            <label class="form-label">Letalo <small class="text-light"
                                                    v-if="prikaz === 'piloti'">(opcijsko)</small></label>
            <div class="dropdown">
              <button class="input border-0 rounded-4 p-2 fs-5 w-100" type="button" @click="dLetalo = !dLetalo"
                      style="text-align: left;">
                {{ izbranoLetaloNaziv || (prikaz === 'piloti' ? 'Vsa letala' : 'Izberi letalo') }}
              </button>
              <transition name="fade">
                <drop-down v-if="dLetalo" @custom="selectLetalo" :data="letalaZaIzbiro" type="custom"
                           class="drop-down-btn"/>
              </transition>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label d-block">Primerjava</label>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" v-model="primerjavaVklopljena" id="primerjavaSwitch">
              <label class="form-check-label" for="primerjavaSwitch">
                Primerjaj z letom
                <select v-model="primerjavaLeta" class="form-select form-select-sm d-inline-block w-auto ms-2">
                  <option v-for="leto in leta" :key="leto.id" :value="leto.id">{{ leto.naziv }}</option>
                </select>
              </label>
            </div>
          </div>

          <div class="col-12">
            <button @click="PocistiFiltre" class="btn btn-outline-secondary me-2">
              <i class="fas fa-eraser"></i> Pocisti filtre
            </button>
          </div>
        </div>
      </div>
    </div>

    <Transition name="fade" mode="out-in">
      <porocilo-skupno
          v-if="prikaz === 'vse' && jeFilterVeljavno"
          :key="'vse-' + datumOd + '-' + datumDo + '-' + (primerjavaVklopljena ? primerjavaLeta : 'brez')"
          :datum-od="datumOd"
          :datum-do="datumDo"
          :primerjavaLeto="primerjavaVklopljena ? primerjavaLeta : null"
          @odjava="$emit('odjava')"
      />

      <porocilo-piloti
          v-else-if="prikaz === 'piloti' && jeFilterVeljavno"
          :key="'piloti-' + izbranPilot + '-' + (izbranoLetalo || 'vsa') + '-' + datumOd + '-' + datumDo + '-' + (primerjavaVklopljena ? primerjavaLeta : 'brez')"
          :pilot="izbranPilot"
          :letalo="izbranoLetalo"
          :datum-od="datumOd"
          :datum-do="datumDo"
          :primerjavaLeto="primerjavaVklopljena ? primerjavaLeta : null"
          @odjava="$emit('odjava')"
      />

      <porocilo-letala
          v-else-if="prikaz === 'letala' && jeFilterVeljavno"
          :key="'letala-' + vrstaLetala + '-' + izbranoLetalo + '-' + datumOd + '-' + datumDo + '-' + (primerjavaVklopljena ? primerjavaLeta : 'brez')"
          :letalo="izbranoLetalo"
          :datum-od="datumOd"
          :datum-do="datumDo"
          :tip="vrstaLetala"
          :primerjavaLeto="primerjavaVklopljena ? primerjavaLeta : null"
          @odjava="$emit('odjava')"
      />

      <porocilo-vleke
          v-else-if="prikaz === 'vleke' && jeFilterVeljavno"
          :key="'vleke-' + izbranoLetalo + '-' + datumOd + '-' + datumDo + '-' + (primerjavaVklopljena ? primerjavaLeta : 'brez')"
          :letalo="izbranoLetalo"
          :datum-od="datumOd"
          :datum-do="datumDo"
          :primerjavaLeto="primerjavaVklopljena ? primerjavaLeta : null"
          @odjava="$emit('odjava')"
      />

      <div v-else class="alert alert-info">
        <i class="fas fa-info-circle"></i> Prosim izpolni vse potrebne filtre za prikaz porocila.
      </div>
    </Transition>
  </div>
  <div class="w-100 mt-4">
    <!-- ODMIK -->
  </div>
</template>